module.exports = "/_next/static/images/alerts@2x-3ce10b0606b2c475a3ea29a01b0444fb.png";